import { css } from '@emotion/core';
import { media, tokens, applyFont } from '@domain-group/fe-brary';
import * as _appearance from './button-appearances.style';
export { _appearance as appearance };
var typography = tokens.typography;
export var linkButton = {
  name: "jymcse",
  styles: "a&:link{display:inline-flex;justify-content:center;}a&:link:after{display:none;}"
};
export var button = /*#__PURE__*/css(applyFont(typography.bodyBold), " min-height:44px;padding:8px 16px;");
export var smallButton = /*#__PURE__*/css(applyFont(typography.bodyBold), " min-height:32px;padding:4px 16px;");
export var largeButton = /*#__PURE__*/css(applyFont(typography.bodyBold), " min-height:60px;padding:18px;");
export var responsiveButton = /*#__PURE__*/css(smallButton, " ", media('>=tablet'), "{", button, ";}");
export var iconOnlySmall = {
  name: "1o01xn9",
  styles: "height:32px;width:32px;"
};
export var iconOnlyLarge = {
  name: "yqm9dt",
  styles: "height:60px;width:60px;"
};
export var iconOnly = {
  name: "1tyajgx",
  styles: "height:44px;width:44px;"
};
export var iconOnlyResponsive = /*#__PURE__*/css(iconOnlySmall, " ", media('>=tablet'), "{", iconOnly, "}");